import { render, staticRenderFns } from "./NilaiSiswaList.vue?vue&type=template&id=08884454&scoped=true"
import script from "./NilaiSiswaList.vue?vue&type=script&lang=js"
export * from "./NilaiSiswaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08884454",
  null
  
)

export default component.exports